(() => {
  const label = document.currentScript.dataset.verifiedLabel;
  const reviews = document.getElementById('judgeme_product_reviews');
  if (!label || !reviews) return;

  const updateBadges = () => {
    reviews.querySelectorAll('.jm-verified-buyer-badge__text').forEach((badge) => {
      if (badge.textContent !== label) badge.textContent = label;
    });
  };

  updateBadges();
  new MutationObserver(updateBadges).observe(reviews, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
